import { cn } from "@/utils";
import { useSelf } from "@liveblocks/react";
import { CommentPin } from "@liveblocks/react-ui";

import { PIN_ICON_SIZE } from "../components/CanvasPinAffordance";
import { CanvasCommentIdentityAvatar } from "./CanvasCommentPreviewCard";

/**
 * The pin you are about to drop, wearing your own face — the placement ghost
 * and the draft the composer opens on are the same object at two moments, so
 * they render from one component.
 */
export function CanvasCommentSelfPin({ className }: { className?: string }) {
  const self = useSelf();

  return (
    <div className={cn("canvas-comments", className)}>
      <CommentPin corner="bottom-left" size={PIN_ICON_SIZE}>
        <CanvasCommentIdentityAvatar
          name={self?.info?.name}
          src={self?.info?.avatar}
          className="size-8"
        />
      </CommentPin>
    </div>
  );
}
